import { Stack as MuiStack, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const Stack = styled(MuiStack, {
  name: actionBarName,
  overridesResolver: (_props, styles) => styles.stack,
  slot: "Stack"
})(() => ({}));
export {
  Stack
};
//# sourceMappingURL=Stack.js.map
